import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getCatalogoCondicao } from '../../../../formularios/core/condicao/catalogo'
import { obterVersaoModelo } from '../../../core/_requests'

/**
 * Versão do modelo da plataforma do `:id` da rota e o catálogo de condições, que traduz as regras
 * e condições de exibição para pt-BR.
 */
export const useVersaoModelo = () => {
  const { id } = useParams()
  const idVersao = Number(id)

  const versao = useQuery(
    ['protocolos-triagem', 'modelo-versao', idVersao],
    () => obterVersaoModelo(idVersao),
    { enabled: !!idVersao, retry: false }
  )
  const { data: catalogo } = useQuery(['condicao', 'catalogo'], () => getCatalogoCondicao(), {
    retry: false,
    staleTime: 60 * 60 * 1000,
  })

  return { ...versao, catalogo }
}
